import { SanityPageSequence, SanityStepperLink } from "../../model/common";
import { internalLinkUrl } from "../InternalLink/InternalLink";

export interface StepData extends SanityStepperLink {
  to: string;
  active: boolean;
  visited: boolean;
  stepNumber: number | null;
}

export const getStepData = (
  pages: SanityPageSequence[],
  pathname: string,
  language: string
): StepData[] => {
  let afterActiveStep = false;
  return pages.map((page, index) => {
    const to = internalLinkUrl(
      page.pageReference,
      undefined,
      undefined,
      language
    );
    if (to === pathname) {
      afterActiveStep = true;
    }
    const pageData = {
      ...page.pageReference,
      to,
      active: to === pathname,
      visited: !afterActiveStep && to !== pathname,
      stepNumber: index + 1
    };
    return pageData;
  });
};

export const getNextStep = (
  stepData: StepData[],
  onward: SanityStepperLink,
  language: string,
  titleOverride?: string
): StepData => {
  const activeStepIndex = stepData.findIndex(step => step.active);
  const isLastStep = activeStepIndex === stepData.length - 1;
  const nextStepIndex = activeStepIndex + 1;
  return {
    ...onward,
    to: !isLastStep
      ? stepData[nextStepIndex].to
      : onward
      ? internalLinkUrl(onward, undefined, undefined, language)
      : "",
    title: titleOverride
      ? titleOverride
      : !isLastStep
      ? stepData[nextStepIndex].title
      : onward?.title,
    stepNumber: !isLastStep ? nextStepIndex + 1 : null,
    active: true,
    visited: false
  };
};
